<script>
import Swal from "sweetalert2";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import {publicUpload} from '@/apis/file'
import {serviceOrderDetail,serviceOrderConfirm} from '@/apis/order'
import {formatDate,downFile,lookup2} from '@/apis/common'
import LanguageSwitch from '../../components/language-switch';
import {
  required
} from "vuelidate/lib/validators";
/**
 * Form Repeater component
 */
export default {
  page: {
    title: "Confirmation Letter Return Receipt",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout,LanguageSwitch},
  validations: {
    form:{
      fileName: { 
        required,
      }
    }
  },
  props:{
    serviceId:{
      type: String,
      required: true
    }
  },
  data() {
    return {
      action:"new",
      serviceOrder:{},
      lookupRawData:{},
      lookupData:{
        orderType:[],
      },
      form:{
        fileName:"",
      },      
      fileOrgName:"",
      submitted:false,
      success:false,
      error:false,
      errorMsg:""
    };
  },
  created(){
    if(this.$route.query.serviceId!=undefined){
      this.serviceId = this.$route.query.serviceId;
    }
    this.init();
  },
  mounted() {
  },
  computed:{
    clientName(){
      return this.serviceOrder.clientName
    },
    clientNameEn(){
      return this.serviceOrder.clientNameEn
    },
    serviceType(){
      if(this.lookupData.orderType.length>0){
        if(this.serviceOrder.serviceType=="SLCP"||this.serviceOrder.serviceType=="Higg"){
          return this.serviceOrder.serviceType+" "+this.serviceOrder.orderDetail.type+" "+this.serviceOrder.orderDetail.model+" Verification";
        }else{
          let items = this.lookupData.orderType.filter(item=>item.value==this.serviceOrder.serviceType);
          if(items.length>0){
            if(localStorage.getItem('language')=="zh-CN"){
              return items[0].labelCn;
            }else{
              return items[0].labelEn;
            }
          }          
        }
      }
      return this.serviceOrder.serviceType
    },
    serviceDate(){
      if(this.serviceOrder.startDate==this.serviceOrder.endDate){
        return formatDate(this.serviceOrder.startDate,"yyyy-MM-dd")
      }else{
        return formatDate(this.serviceOrder.startDate,"yyyy-MM-dd")+"-"+formatDate(this.serviceOrder.endDate,"MM-dd")
      }
    },
    showInput(){
      if(this.serviceOrder.serviceStatus=="SC" && (this.serviceOrder.confirmationLetterReceipt==null|| this.serviceOrder.confirmationLetterReceipt=="")){
        return true;
      }else{
        return false;
      }
    }
  },
  watch:{
  },
  methods: {
    async init(){
      this.lookupRawData = await lookup2("ORDER-TYPE");
      this.lookupData.orderType = this.lookupRawData["ORDER-TYPE"].map(item=>{return {...item,labelCn:item.label}});
      await serviceOrderDetail(this.serviceId).then((res)=>{
        this.serviceOrder = res.data
      }).catch((res)=>{
        this.error = true
        if(res.message=="ERR_DATA_NONEXIST"){
          this.errorMsg = this.$t("confirm_letter.notExist")
        }else{          
          this.errorMsg = this.$t("confirm_letter.error")
        }        
      })
    },
    handleConfirm() {
      this.submitted = true;
        this.$v.$touch();
        if (this.$v.$invalid) {
            return;
        } else {
          let params = {
            "confirmationLetterReceipt":this.fileOrgName,
            "serviceId":this.serviceId
          }
          serviceOrderConfirm(params).then(()=>{
            this.success = true
            Swal.fire(this.$t("confirm_letter.success"),"", "success")
            this.init()
          }).catch(()=>{
            Swal.fire(this.$t("confirm_letter.submitError"),"", "error");
          })
        }
    },
    handleGoHome(){
      this.$router.push({
          name: 'home',
      })
      
    },
    handleSelectFile(){
      this.$refs.attachment.click()
    },
    changeFile(){
      if(this.$refs.attachment.files.length==1){
        this.form.fileName = this.$refs.attachment.files[0].name
          const formData = new FormData();
          formData.append("files",this.$refs.attachment.files[0]);
          formData.append("type","confirmLetter");
          formData.append("id",this.serviceId);
          formData.append("fileName",this.$t("confirm_letter.confirmLetter"));
          publicUpload(formData).then((res)=>{
              this.fileOrgName = res.data[0].fileOrgName
              this.handleConfirm()
          })
      }
    },
    handleDownload (){
        const url=`/api-gateway/service/download?fileType=SERVICE&fileName=${this.serviceOrder.confirmationLetterReceipt}`
        downFile(url,this.$t("confirm_letter.confirmLetter"));
    },
  },
};
</script>

<template>
  <Layout>
    <div class="row  mt-4">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body" style="padding-top: 0px;">
                        <div class="row">
                          <div class="col-lg-2 col-sm-1 logo-col" >
                            <a href="http://www.greenpont.com/" class="logo">
                                <span class="logo-sm">
                                  <img src="@/assets/images/logo-sm.svg" alt height="22" />
                                </span>
                                <span class="logo-lg">
                                  <img src="@/assets/images/logo-dark.svg" alt height="36" />
                                </span>
                            </a>
                          </div>
                          <div class="col-lg-8 col-sm-10 text-center" >
                            <h5 class="card-title" style="line-height: 70px;"><span class="logo-icon">
                              <a href="http://www.greenpont.com/"><img src="@/assets/images/logo-sm.svg" alt height="22" /></a>
                              </span></h5>
                          </div>
                        </div>
                        <language-switch></language-switch>
                        <form class="needs-validation">
                          <div class="card border shadow-none mb-5">
                                <div class="card-header d-flex align-items-center">
                                    <div class="flex-grow-1">
                                        <h5 class="card-title">{{$t("confirm_letter.confirmLetter")}}</h5>
                                    </div>
                                </div>
                                <div class="card-body" v-if="error">
                                  <b-alert
                                    v-model="error"
                                    variant="danger"
                                    class="mt-3"
                                    dismissible
                                    >{{ errorMsg }}</b-alert
                                  >
                                </div>
                                <div class="card-body" v-if="!error">
                                  <div class="row mb-3">
                                      <div class="col-md-3 col-sm-6"><strong>{{$t("common.clientNameLocal")}}</strong></div>
                                      <div class="col-md-9 col-sm-6">{{clientName}}</div>
                                    </div>
                                    <div class="row mb-3">
                                      <div class="col-md-3 col-sm-6"><strong>{{$t("common.clientNameEn")}}</strong></div>
                                      <div class="col-md-9 col-sm-6">{{clientNameEn}}</div>
                                    </div>
                                    <div class="row mb-3">
                                      <div class="col-md-3 col-sm-6"><strong>{{$t("fem.type")}}</strong></div>
                                      <div class="col-md-9 col-sm-6">{{serviceType}}</div>
                                    </div>
                                    <div class="row mb-3">
                                      <div class="col-md-3 col-sm-6"><strong>{{$t("common.verificationDate")}}</strong></div>
                                      <div class="col-md-9 col-sm-6">{{serviceDate}}</div>
                                    </div>
                                    <div class="row mb-3">
                                      <div class="col-md-3 col-sm-6"><strong>{{$t("confirm_letter.confirmLetter")}}</strong></div>
                                      <div v-if="showInput" class="col-md-9 col-sm-6">
                                        <input
                                          class="form-control mb-1"
                                          id="promoteBrand"
                                          v-model="form.fileName"
                                          :class="{ 'is-invalid': submitted && $v.form.fileName.$error }"
                                          disabled
                                        />
                                        <input ref="attachment" type="file" aria-label="Upload" placeholder="" style="display: none;" @change="changeFile">
                                        <div
                                          v-if="submitted && $v.form.fileName.$error"
                                          class="invalid-feedback"
                                        >
                                          <span v-if="!$v.form.fileName.required">{{$t("common.pleaseSelectFile")}}.</span>
                                        </div>
                                        <button type="button" class="btn btn-info w-sm" @click="handleSelectFile">{{$t("common.selectFile")}}</button>
                                      </div>
                                      <div class="col-md-9 col-sm-6" v-if="!showInput"><a href="javascript:" @click="handleDownload">{{$t("common.view")}}</a></div>
                                    </div>
                                </div>
                            </div>
                          </form>
                    </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
<style lang="scss">
.is-invalid .mx-input-wrapper .mx-input{
    border: 1px solid #ec4561 !important;
  }
  .is-invalid .mx-input-wrapper .mx-icon-calendar{
    color: #ec4561 !important;
  }
</style>
